import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Backwards-compatible redirect: /admin/analytics → /admin/track-record?tab=analytics
export default function AdminAnalytics() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/admin/track-record?tab=analytics", { replace: true });
  }, [navigate]);
  return null;
}
